(function() {

	angular
		.module('ngmvac')
		.factory('HotelFactory', HotelFactory);

	HotelFactory.$inject = ['$window', '$http', 'DatosCotizador', '$q'];

	function HotelFactory($window, $http, DatosCotizador, $q) {

		/*
		* Interfaz publica del provider
		*/

		return {
			obtenerHoteles: obtenerHoteles,
			obtenerHotel: obtenerHotel,
			obtenerListHoteles: fnobtenerListHoteles,
			checkPreviusAvailability: checkPreviusAvailability,
			getRateComments: getRateComments,
			getIssues: getIssues,
			cancelOperation: cancel,
			getCountries : getCountries,
			getDestinos : getDestinos,
			contentDownload : contentDownload,
			getHotelsByDestiny 	: getHotelsByDestiny,
			getCadena : getCadena,
			getCotizador: getCotizador,
			getDestinations : getDestinations,
			getZones : getZones,
			getAllDestinos : getAllDestinos,
			recotizarhotel: recotizarHotel,
			guardarcorreo: guardarCorreoContacto,
			getHotelsByParam : getHotelsByParam,
			obtenerHotelesDB : obtenerHotelesDB,
			deleteLocalStorage: deleteLocalStorage,
			isLocalStorageAvailable: isLocalStorageAvailable,
			getTopDestinos: getTopDestinos,
			getUpdatepaises:getUpdatepaises,
			getUpdatezonas:getUpdatezonas,
			getCurrencies : getCurrencies,
			setCurrency : setCurrency,
			enviaCotizacion: enviaCotizacion,
			imgDefaultGEN:imgDefaultGEN,
			getMxDestinations: getMxDestinations,
			gedatdetails: getdetails,
			clavesInternacionales: clavesInternacionales
		}

		/*
		* Obtiene los hoteles desde el cotizador
		*/
 
        function guardarCorreoContacto(nombre,apellido,correo) {
			return $http.get('/guardar_correo', {params:{'nombre': nombre,'apellido':apellido,'correo':correo}});
			
		}
		function obtenerHoteles() {
			if (isLocalStorageAvailable()) {
				localStorage.setItem('search', JSON.stringify(DatosCotizador));
			}
		}

		function fnobtenerListHoteles() {
			if (isLocalStorageAvailable()) {
				localStorage.setItem('search', JSON.stringify(DatosCotizador));
			}

			return $http.post('/search', DatosCotizador);
		}

		function obtenerHotelesDB(){
			return $http.post('/searchDB', DatosCotizador);
		}

		function recotizarHotel(DatosCotizador) {
			if (isLocalStorageAvailable()) {
				localStorage.setItem('search', JSON.stringify(DatosCotizador));
			}
			return $http.get('/recotizar', {params:{'datos': DatosCotizador}});
			
		}

		function getMxDestinations() {
			return $http.get('/mx-destinations');
		}

		/*
		* Obtiene un hotel especifico
		*/

		function obtenerHotel(code, flt, search) {
			if (typeof flt === 'undefined') {
				flt = '';
			}
			var search = JSON.parse(localStorage.getItem('search'));
			var res = JSON.parse(localStorage.getItem('hotelSelected'));
			var deferred = $q.defer();
			var existeHotel = false
			var hotelCode = 0;
			var searchCode = false;
			/*
			1 hotel con codigo
			2 hotel sin codigo
			testing:
			buscador con auto
			recotizar en detalles
			buscador solo hotel
			de lista a detalles
			*/
			if(isLocalStorageAvailable){
				if(res){
					if(parseFloat(search.destination.hotelCode)){
						//si hay una busqueda solo hotel
						if( parseFloat(res.code) === parseFloat(search.destination.hotelCode) ){
							hotelCode = search.destination.hotelCode
							existeHotel = false
						}else{
							if(localStorage.getItem('page') == 'detalles'){
								hotelCode = res.code
								existeHotel = false
							}else if(localStorage.getItem('page') == 'inicio' && (localStorage.getItem('hotelSelected')) == null){
								hotelCode = search.destination.hotelCode
								existeHotel = false
							}else if(localStorage.getItem('page') == 'inicio' && (localStorage.getItem('hotelSelected')) != null){
								hotelCode = res.code
								existeHotel = false
							}else{
								if(parseFloat(search.destination.hotelCode)){
									hotelCode = search.destination.hotelCode
									existeHotel = false
								}else if(parseFloat(res.code)){
									hotelCode = res.code
									existeHotel = false
								}
							}
						}
					}else{
						// tomar codigo en searches
						searchCode = true;
					}
				}else{
					// tomar codigo en searches
					searchCode = true;
				}

				if(searchCode){
					if(parseFloat(search.destination.hotelCode)){
						hotelCode = search.destination.hotelCode
						existeHotel = false
					}else if(res !== null){
						hotelCode = res.code
						existeHotel = false
					}else{
						if(localStorage.getItem('searches')){
							hoteles = JSON.parse(localStorage.getItem('searches'));
							ultimoHotel = hoteles[hoteles.length - 1].hotel;
							hotelCode = ultimoHotel.code
							existeHotel = false
						}else{
							existeHotel = true
						}
					}
				}
			}

			if(!existeHotel){	
				var getHotel = getdetails(search, hotelCode);
				return getHotel;
			}else{
				deferred.reject({
					total: 0
				});
				return deferred.promise; 
			}
		}

		function getdetails(search, hotelCode){
			var pagination = {"page":1,"limit":1,"totalFiltered":0}; 
			var orderBy = {"type":"categoryCode","value":"DEFAULT"}; 
			var withCar = false;
			var enableFreeCar = document.querySelector('#enableFreeCar').value === 'true' ? true : false;
			var allowedBoard = document.querySelector('#allowedBoard').value;
			if(enableFreeCar && localStorage.getItem('cotizadorSeleccionado') == 1){
				withCar = true;
			}
			var deferred = $q.defer();
			var enLocalStorage = true;
			const paramsUrl = [
				`search=${encodeURIComponent(JSON.stringify(search))}`,
				`pag=1`,
				`board=`,
				`pagination=${encodeURIComponent(JSON.stringify(pagination))}`,
				`orderBy=${encodeURIComponent(JSON.stringify(orderBy))}`,
				`keywords=`,
				`zones=`,
				`categoriesFilter=`,
				`frequentCustomerId=`,
				`withCar=${withCar}`,
				`enableFreeCar=${enableFreeCar}`,
				`allowedBoard=${allowedBoard}`,
				`hotelcode=${hotelCode}`,
				`test=false`,
			].join("&");
				
			return $http.get('https://1uyb3ndys9.execute-api.us-west-1.amazonaws.com/Prod/hotel/checkavailability?' + paramsUrl)
			.then(function (response) {
				if (response.status == 200) {
					var getHotel = null;
						deferred.resolve({
							data: {
								hotel: response.data.hotels[0],
								packAuto: false,
								total: 1,
								search: search, 
								availability: true
							}
						});
			
					if (typeof response.data.hotels[0] === 'object') {
						getHotel = JSON.stringify(response.data.hotels[0]);
					} else {
						getHotel = response.data.hotels[0];   
					}

					localStorage.setItem('hotelSelected', getHotel);
					hBack = JSON.parse(localStorage.getItem('hotelSelected'));
					searches = localStorage.getItem('searches') == null || localStorage.getItem('searches').length 
					== 0 ? [] : JSON.parse(localStorage.getItem('searches'))

						if (searches.find(element => element.hotel.code == hBack.code) === undefined) {
							enLocalStorage = false
						}else{
							searches.pop()
							enLocalStorage = false
						}

						if (!enLocalStorage) {
							if (searches.length >= 3) {
								searches.shift();
							}
							searches.push({
								hotel: hBack,
								search: JSON.parse(localStorage.getItem('search'))
							});
							localStorage.setItem('searches', JSON.stringify(searches));
						}
					
				}else{
					deferred.reject({
						total: 0
					});
				}
				return deferred.promise; 
			})
			.catch(function(response){
				deferred.reject({
					total: 0
				});
				return deferred.promise;  
			});
		}

		/*
		* Verifica si hay una busqueda en sesion
		*/

		function checkPreviusAvailability(step) {
			search = this.getCotizador();
			return $http.get('/hotel/checkavailability', {params:{'step': step, 'search': search}})
				.then(function (response) {
					if (response.status == 200) {
						if (isLocalStorageAvailable()) {
							var search = null;

							if (typeof response.data.search === 'object') {
								search = JSON.stringify(response.data.search);
							} else {
								search = response.data.search;
							}
							
							localStorage.setItem('search', search);
						}
				}
					return response;
				});
		}

		/*
		* Trae los ratesComments de una selección
		*/

		function getRateComments(ratesComments) {
			return $http.post('/hotel/ratecomments', ratesComments);
		}

		function getIssues(issues) {
			return $http.post('/hotel/issues', issues);
		}

		function cancel() {
			return $http.post('/cancel/operation');
		}

		function getCountries(){
			return $http.get('/api/paises');
		}

		function getDestinos(params){
			return $http.get('/api/destinos_', params);
		}

		function getAllDestinos(params){
			return $http.get("/api/destinos");
		}

		function contentDownload(params){
			return $http.get('/content_admin/download', params);
		}

		function getHotelsByDestiny(params){
			return $http.get('/api/hoteles_', params);
		}

		function getCadena(params){
			return $http.post("/api/get_cadena", params);
		}

		function getCotizador(params) {
			if (isLocalStorageAvailable()) {
				return JSON.parse(localStorage.getItem('search'));
			}
		}

		function getDestinations(){
			return $http.get('/api_destino.json');
		}

		function getZones(){
			return $http.get('/api_zonas.json');
		}

		function getHotelsByParam(step){
			return $http.get('/hotel/getHotelsByParam', {params: {step: step}});
		}

		function deleteLocalStorage() {
			if (isLocalStorageAvailable()) {
				localStorage.removeItem('hotelSelected');
				localStorage.removeItem('search');
			}
		}

		function getTopDestinos(type) {
			return $http.get('/hotel/top/' + type);
		}

		function getCurrencies(){
			return $http.get('/hotel/currencies');
		}

		function setCurrency(currency){
			return $http.get('/hotel/setCurrency/' + currency.divisa + '/' + currency.title + '/' + currency.simbolo  + '/' + currency.country);
		}

		/*
		* Comprueba que el localStorage este habilitado en el dispositivo
		*/

		function isLocalStorageAvailable() {
			var support;
			
			try {
				support = $window.localStorage;
			} catch( err) {
				support = false;
			}

			if( support ) {
				try {
					$window.localStorage.setItem('_x', 'x');
					$window.localStorage.removeItem('_x');
				} catch(err) {
					support = false;
				}
			}

			return support;
		}

		function getUpdatepaises()
		{
			return $http.get('/getupdatepaises');
		}

		function enviaCotizacion(data) {
			return $http.post('/cotizacion/enviar', data);
		}

		function clavesInternacionales(){
			return $http.get('/clavesInternacionales');
		}

		
		function getUpdatezonas(inicio, fin)
		{
			console.log(inicio);
			console.log(fin);
			return $http.get('/getupdatezonas',{ 
				params : {
					     'inicio': inicio,
					     'fin': fin
                       }
                   });
		}

		function imgDefaultGEN(params){
			return $http.post('/hotel/imagen_defaul',params);
		}
	}

})();
